import auth from './auth'
import app from './app'
import fs from './fs'
import scm from './scm'

export default { app, fs, auth, scm }
